import { Job, JobType } from "./job";

export class TransportJob extends Job {
    fromLocation: Location = [];
    toLocation: Location = [];
    type: JobType  = JobType.TRANSPORT;
}